import React from 'react';
import Editor from '@monaco-editor/react';
import clsx from 'clsx';
import { ErrorBoundary } from '@tribeplatform/react-components/common';
export const CodeEditor = props => {
    const { defaultLanguage, initialValue, onChange: onEditorChange } = props;
    return (React.createElement(ErrorBoundary, null,
        React.createElement("div", { className: "flex relative border border-line-subdued shadow-sm ignore-typography" },
            React.createElement("div", { className: clsx('block w-full', 'focus:ring-focused focus:border-focused', 'text-content-on-background-subdued placeholder:text-content-on-background-subdued placeholder:opacity-60 ') },
                React.createElement(Editor, { defaultValue: initialValue, onChange: onEditorChange, height: "50vh", defaultLanguage: defaultLanguage })))));
};
//# sourceMappingURL=CodeEditor.js.map